export const setOpenSessionModal = () => {
	return {
		type: 'open_session_modal',
	};
};
export const setCloseSessionModal = () => {
	return {
		type: 'close_session_modal',
	};
};
